import { render, staticRenderFns } from "./SingleEmployee.vue?vue&type=template&id=4e8af9db&scoped=true"
import script from "./SingleEmployee.vue?vue&type=script&lang=js"
export * from "./SingleEmployee.vue?vue&type=script&lang=js"
import style0 from "./SingleEmployee.vue?vue&type=style&index=0&id=4e8af9db&prod&lang=scss"
import style1 from "./SingleEmployee.vue?vue&type=style&index=1&id=4e8af9db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8af9db",
  null
  
)

export default component.exports